package com.shadowings.gero.data.lessons.chapter8

import com.shadowings.gero.data.lessons.buildVsoRecapWordSelectionQuizzes
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.domain.model.WordSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_ending_vso_alyn_1
import gero.composeapp.generated.resources.exp_content_ending_vso_alyn_2
import gero.composeapp.generated.resources.exp_content_ending_vso_alyn_3
import gero.composeapp.generated.resources.exp_content_ending_vso_masko_1
import gero.composeapp.generated.resources.exp_content_ending_vso_masko_2
import gero.composeapp.generated.resources.exp_content_ending_vso_masko_3
import gero.composeapp.generated.resources.exp_content_ending_vso_masko_4
import gero.composeapp.generated.resources.exp_content_ending_vso_nilo_1
import gero.composeapp.generated.resources.exp_title_ending_vso
import kotlin.random.Random

fun getEndingVsoContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_alyn_1,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_masko_1,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_nilo_1,
            face = Faces.Serious,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_alyn_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_masko_2,
            face = Faces.Serious,
            character = Characters.Masko,
            composable = {
                MdCWord(
                    word = "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2-D35-U2:D4-A1-W19-X1:Z4-O34:D21-G43-Q3:N35",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_alyn_3,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                MdCWord(
                    word = "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2-D35-U2:D4-A1-W19-X1:Z4-O34:D21-G43-Q3:N35",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_masko_3,
            face = Faces.Serious,
            character = Characters.Masko,
            composable = {
                MdCWord(
                    word = "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2-D35-U2:D4-A1-W19-X1:Z4-O34:D21-G43-Q3:N35",
                    rtl = false,
                    cart = false
                )
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_ending_vso,
            content = Res.string.exp_content_ending_vso_masko_4,
            face = Faces.Happy,
            character = Characters.Masko,
        )
    )
}

fun getEndingVsoQuizContent(
    languageCode: String,
    verbSentences: List<SentenceOptions>
): List<IQuizContent> {
    val recapQuizzes = buildVsoRecapWordSelectionQuizzes(
        random = Random,
        languageCode = languageCode,
        count = 10,
        verbSentences = verbSentences
    )

    return recapQuizzes.mapIndexed { index, quiz ->
        if (quiz is WordSelectionContent && index % 2 == 0) {
            TextTranslationContent(
                hieroglyphs = quiz.hieroglyphs,
                correctPhrase = quiz.correctPhrase,
                transliteration = quiz.transliteration,
                soggettiCount = quiz.soggettiCount,
                oggettiCount = quiz.oggettiCount,
                id = quiz.id
            )
        } else {
            quiz
        }
    }
}
